import { Injectable } from '@angular/core';
import { TaskUtils } from '@tasks/tasks.utils';

import { Task } from '../tasks.types';

@Injectable({
  providedIn: 'root',
})
export class TaskGroupService {
  constructor() {}

  transformDataToAgGridTreeData = (tasks: Task[]): any => {
    return TaskUtils.flattenTasks(
      tasks.reduce((acc, task: Task) => {
        const setPath = (task: Task, parentPath: number[] = []) => {
          task['path'] = [...parentPath, task.id];
          if (task.children && task.children.length > 0) {
            task.children.forEach((child: Task) => setPath(child, task['path']));
          }
        };
        setPath(task);
        return [...acc, task];
      }, []),
    ) as any[];
  };
}
